const steps = [
  {
    icon: "ri-compass-3-line",
    title: "选择平台",
    desc: "在资源库中按手机、电脑、安卓、汉化或免安装版筛选，找到适合自己的同人游戏。",
  },
  {
    icon: "ri-download-cloud-line",
    title: "下载安装包",
    desc: "进入游戏详情页，根据当前设备选择对应的安装包或压缩包下载。",
  },
  {
    icon: "ri-box-3-line",
    title: "安装 / 解压",
    desc: "安卓安装 APK 并允许未知来源；电脑版解压压缩包，路径避免中文即可。",
  },
  {
    icon: "ri-play-circle-line",
    title: "启动游玩",
    desc: "首次启动会加载少量资源，完成后即可进入火影世界畅快开玩。",
  },
];

export default function DownloadGuide() {
  return (
    <section id="guide" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
            Download Guide
          </p>
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            下载指南 · 三步进入游戏
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
            第一次玩同人游戏也没关系，跟着下面的步骤走，从下载到开玩全程无障碍。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, i) => (
            <div
              key={step.title}
              className="relative rounded-lg bg-background-50 border border-background-200 p-6"
            >
              <span className="font-heading absolute right-5 top-4 text-4xl font-black text-primary-200">
                0{i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 text-white">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-lg bg-secondary-100 p-6 sm:flex-row">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-white">
              <i className="ri-alert-line text-lg"></i>
            </span>
            <div>
              <p className="text-sm font-bold text-secondary-900">下载提示</p>
              <p className="mt-1 text-sm leading-6 text-secondary-900/80">
                建议优先通过官方或可信渠道获取安装包；下载后可使用杀毒软件扫描确认安全。本站仅整理同人资源的信息指引。
              </p>
            </div>
          </div>
          <a
            href="#faq"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("faq")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="whitespace-nowrap rounded-md bg-secondary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-secondary-600"
          >
            遇到问题看这里
          </a>
        </div>
      </div>
    </section>
  );
}